import https from 'https'
import axios from 'axios'
import config from '@/config'
import store from '@/store'

// console.log('api.js')
// console.log(JSON.stringify(store.getters.token))
// console.log(`${store.state.isAuthenticated}`)

var axiosInstance
var axiosSetInterval
// var axiosElasticsearchInstance = axios.create({
//   baseURL: 'https://opendata.mes.meca.in.th:9200/meca-bill/_search',
//   crossDomain : true
// });

function initAxios () {
	// console.log('initAxios')
	// console.log(`${store.state.user.token}`)
	axiosInstance = axios.create({
		baseURL: config.backend.api_endpoint,
		headers: {
			'Authorization': `Bearer ${store.state.user.token}`,
			'Access-Control-Allow-Origin' : '*'
		},
		httpsAgent: new https.Agent({  
			// rejectUnauthorized: false,
			ca: config.backend.ca
		}),
		crossDomain : true
		/* other custom settings */
	})
} 


// module.exports = axiosInstance;

// export default axiosInstance;
export { initAxios, axiosInstance, axiosSetInterval }